/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/ConfirmationDialog.Props" />
export interface IConfirmationDialogProps {
    title: string;
    message: string;
    primaryButtonText: string;
    onConfirmed: () => void;
    onCancel: () => void;
}
